import { useCallback, useState } from 'react';

import { toast } from 'react-toastify';

import { useAppDispatch, useAppSelector } from 'redux/store/store.types';
import { AppImage } from 'types';
import * as yup from 'yup';

import { setUserIdDocumentModalOpen } from 'modules/auth-session';
import { EMediaCollections, useMedia } from 'modules/media';

import FormikForm from 'components/common/FormikForm';
import NInputImage from 'components/common/FormikForm/NInputImage';
import NibButton from 'components/common/NibButton/NibButton';
import { NibCard } from 'components/common/NibCard';
import NibDialog from 'components/common/NibDialog/NibDialog';

type InitialValues = {
  document: AppImage | File | null;
};

const initialValues: InitialValues = {
  document: null,
};

const validationSchema = yup.object({
  document: yup.object().nullable(),
});

export default function UserIdDocumentModal() {
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(window.location.search);
  const returnUrlParam = params?.get('returnUrl');
  const { currentUser, userIdDocumentModalOpen } = useAppSelector((store) => store.authSession);

  const { uploadMediaHandler } = useMedia();

  const [formData] = useState<InitialValues>(initialValues);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback(
    async (values: InitialValues) => {
      if (!values.document) {
        toast.error('Please upload a document');
        return;
      }
      if (isLoading || !currentUser) return;
      setIsLoading(true);
      const result = await uploadMediaHandler({
        collection: EMediaCollections.ID_DOCUMENT,
        id: currentUser.id,
        modelType: currentUser.model_type,
        files: [values.document as File],
      });
      setIsLoading(false);
      if (result) {
        toast.success('Document uploaded successfully');
        dispatch(setUserIdDocumentModalOpen(false));
        if (returnUrlParam) {
          window.location.href = returnUrlParam;
        }
      }
    },
    [currentUser, isLoading, returnUrlParam],
  );

  if (!currentUser) return null;
  return (
    /*  @ts-ignore */
    <NibDialog title="Upload you ID" open={userIdDocumentModalOpen} disableBackdropClick>
      {/* @ts-ignore */}
      <div>
        <FormikForm validationSchema={validationSchema} initialValues={formData} onSubmit={onSubmit} enableReinitialize>
          {(formik: any) => (
            <div className="n-card-group n-size-1">
              <div className="n-card-body">
                {/* @ts-ignore */}
                <NibCard>
                  {/* @ts-ignore */}
                  <NInputImage
                    name="document"
                    formik={formik}
                    accept={['.jpg', '.png', '.jpeg']}
                    label="Document"
                    withAddBtn={false}
                  />
                </NibCard>

                <div className="pt-[100px] flex gap-4 flex-col">
                  {/* @ts-ignore */}
                  <NibButton
                    className="n-button-big-red"
                    type="submit"
                    isLoading={isLoading}
                    disabled={isLoading}
                    label="Upload Your ID"
                  />
                </div>
              </div>
            </div>
          )}
        </FormikForm>
      </div>
    </NibDialog>
  );
}
